import { useLanguage } from '@shared/contexts/LanguageContext'
import { GuardianExpoSection } from './GuardianExpoSubPageLayout'

/**
 * 活動影音區塊（橫向卡片列表，無資料時顯示「敬請期待」）
 * videos: [{ id, thumbnail, title, onClick }]
 */
export default function ActivityVideosSection({ videos = [], first = false, last = false }) {
  const { t } = useLanguage()

  return (
    <GuardianExpoSection
      titleBlack={t('guardianExpo.activityVideosTitleBlack')}
      titleRed={t('guardianExpo.activityVideosTitleRed')}
      first={first}
      last={last}
    >
      {videos.length === 0 ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px 0' }}>
          <span style={{ fontFamily: 'Noto Serif TC', fontSize: 16, fontWeight: 400, color: 'rgba(188,49,61,0.5)', letterSpacing: '0.2em' }}>
            {t('guardianExpo.activityVideosEmpty')}
          </span>
        </div>
      ) : (
        <div className="overflow-x-auto no-scrollbar" style={{ display: 'flex', gap: 12 }}>
          {videos.map((video) => (
            <div
              key={video.id}
              className="cursor-pointer"
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, width: 155, flexShrink: 0 }}
              onClick={video.onClick}
            >
              <div style={{ width: 155, height: 155, position: 'relative', background: 'white', boxShadow: '2px 4px 8px rgba(110,98,91,0.08)', borderRadius: 20, border: '1.1px solid rgba(110,98,91,0.08)', overflow: 'hidden' }}>
                {video.thumbnail && (
                  <img src={video.thumbnail} alt={video.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                )}
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.15)' }}>
                  <span className="material-symbols-outlined" style={{ color: 'rgba(255,255,255,0.85)', fontSize: 32 }}>play_arrow</span>
                </div>
              </div>
              <p className="line-clamp-2 text-center" style={{ color: '#6E625B', fontSize: 18, fontFamily: 'Noto Sans TC', fontWeight: 400, lineHeight: '27px', width: '100%', paddingLeft: 16, paddingRight: 16 }}>
                {video.title}
              </p>
            </div>
          ))}
        </div>
      )}
    </GuardianExpoSection>
  )
}
